import React, { useEffect, useRef, useState } from 'react';
import { useView } from '../../../global/hooks/useView';
import { useUser } from '../../../global/hooks/useUser';
import { useSocket } from '../../../global/hooks/useSocket';
import { get, size } from 'global/lib/lodash';
import { Badge, Icon, Popover } from '@mui/material';
import { Button, IconButton } from '../../../global/components/Button';
import { AlertsDropContainer, AlertsDropHeaderRow } from './styles';
import Alerts from '../alerts';
import { Text } from '../../../global/components/text';
import { withRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearNewAlerts, clearNewAlert, getAlerts } from '../../../redux/actions/view';
import { useWindowSize } from '../../../global/hooks/useWindowSize';

export const AlertsDrop = withRouter((props) => {
  const { view } = useView();
  const { me } = useUser();
  const dispatch = useDispatch();
  const screen = useWindowSize();
  const [amt, setamt] = useState(0);
  const [modal, setModal] = useState({
    open: false,
    onClose: () => setModal((m) => ({ ...m, open: false })),
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center',
    },
  });

  const listRef = useRef();

  useEffect(() => {
    setamt(size(view.alerts.new));
  }, [view.alerts.new]);

  const userId = get(me, 'id');

  useSocket(
    {
      channel: `user.${userId}`,
      onEvent: (e) => {
        console.log('userevent', e);

        const ignore = [];

        if (ignore.includes(e.eventName)) {
          return;
        }

        if (e.type === 'read-statuses') {
          dispatch(clearNewAlert(e.data, { send: false }));
          return;
        }

        setTimeout(() => {
          if (modal.open && listRef.current && listRef.current.getPageAlerts) {
            listRef.current && listRef.current.getPageAlerts();
          } else {
            dispatch(getAlerts());
          }
        }, 1000);
      },
    },
    [userId, amt]
  );

  const toggleModal = (e) => {
    setModal((m) => ({ ...m, anchorEl: get(e, 'currentTarget'), open: !m.open }));
  };

  const goToAlerts = () => {
    toggleModal();
    props.history.push('/alerts/all');
  };

  const clearTheAlerts = async () => {
    await dispatch(clearNewAlerts());
  };

  return (
    <div style={{ marginLeft: 8 }}>
      <IconButton data-testid={'navbar-button-alerts'} onClick={toggleModal} variant="outlined" size="large">
        <Badge badgeContent={Math.max(0, amt)} color="secondary">
          <Icon style={{ color: 'white' }}>notifications_active</Icon>
        </Badge>
      </IconButton>

      <Popover {...modal}>
        <AlertsDropContainer isMobileXS={!!screen.isMobileXS} windowSize={screen.windowSize}>
          <AlertsDropHeaderRow>
            <Text type="headline_medium">Alerts</Text>
            <div style={{ marginLeft: 'auto' }}>
              <Button onClick={clearTheAlerts} variant="text" color="secondary">
                mark all as read
              </Button>
              <Button onClick={goToAlerts} variant="text" color="secondary">
                see all
              </Button>
            </div>
          </AlertsDropHeaderRow>

          {modal.open && <Alerts ref={listRef} onClick={toggleModal} noDataText={'No alerts here'} match={{ path: '/alerts/user' }} showRealmFilter={false} clearAll={false} />}
        </AlertsDropContainer>
      </Popover>
    </div>
  );
});
